import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const moviesApi = createApi({
        reducerPath: 'moviesApi',
        baseQuery: fetchBaseQuery({ baseUrl: 'https://powerful-brushlands-40356-03b67b8d3740.herokuapp.com/' }),
        endpoints: (builder) => ({
            getMoviesData: builder.query({
                query: (value) => `find-latest/location.address.city/${value}`,
            }),
         
            getMoviesByLocation: builder.query({
                // Define a new query
                query: (value) => `find-lmovies/location.address.city/${value}`,
            }),
            
            getTheatreByCode: builder.query({
                query: (values) => {
                  // Join the array of values into a comma-separated string and pass it as a single value in the URL
                  const valueString = values.join(',');
                  console.log(typeof(valueString))
                  return `find-theatre/${valueString}`;
                },
              }),
            
        }),
})

export const { useGetMoviesDataQuery , useGetMoviesByLocationQuery, useGetTheatreByCodeQuery } = moviesApi